import { memo } from 'react';

export const Pressable = memo(({ children, style = {}, disabled, onClick, ...p }) => (
  <div {...p} onClick={!disabled && onClick} role={!disabled && 'button'} style={{ ...style }}>
    {children}
  </div>
));

export const Text = memo(({ children, ...p }) => <div {...p}>{children}</div>);
